<template>
  <v-container>
    <v-card>
      <v-card-title> IBL Links </v-card-title>
      <!-- <v-divider /> -->

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="settingsFormData.minor_settings.selected_ibl_links"
          @click:row="clickedLink"
        >
          <template v-slot:[`item.link`]="{ item }">
            <a :href="item.link" target="_blank">{{ item.link }}</a>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "IBL",
  data() {
    return {
      settingsFormData: {
        minor_settings: {
          ibl_link: [],
          selected_ibl_links: [],
          dashboard_links: [],
        },
        site_colors: [],
        site_installed_packages: [],
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch("Profile/getSettings");
  },
  computed: {
    settings() {
      return this.$store.getters["Profile/setupGetter"]("settings");
    },
    headers() {
      return [
        { text: "Name", value: "name", align: "start" },
        { text: "Links", value: "link", align: "start" },
      ];
    },
  },
  methods: {
    clickedLink(event, item) {
      window.open(item.item.link, "_blank");
    },
  },
  watch: {
    settings: {
      handler: async function (val) {
        if (val) {
          this.settingsFormData.minor_settings =
            val && val.minor_settings
              ? JSON.parse(val.minor_settings)
              : this.settingsFormData.minor_settings;
          this.settingsFormData.site_colors =
            val && val.site_colors
              ? JSON.parse(val.site_colors)
              : this.objectToArray(this.$vuetify.theme.themes.light);
          this.settingsFormData.site_installed_packages =
            val && val.site_installed_packages
              ? JSON.parse(val.site_installed_packages)
              : [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
